import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { CurrencyFlagIcon } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { ModalExchangeRate } from "@src/components/widgets/Modals/ModalExchangeRate";
import { useStore } from "@src/utils/hooks";
import { ExchangeRatesTable } from "@src/widgets/tables/ExchangeRatesTable";
import { observer } from "mobx-react-lite";
import type React from "react";
import { type FunctionComponent, type ReactNode, useContext } from "react";
import { PageClientDetailCtx } from "../../PageClientDetail";

export const ModalExchangeRates: FunctionComponent<
  React.PropsWithChildren<{
    isOpen: boolean;
    onClose: () => void;
    title: ReactNode;
  }>
> = observer(function ModalExchangeRates({ title, onClose, isOpen }) {
  const { UIStore, workspaceStore } = useStore();
  const store = useContext(PageClientDetailCtx);

  const code = workspaceStore.settings?.currency.code!;

  const onAddNewRate = () => {
    UIStore.dialogs.openModal({
      content: (
        <ModalExchangeRate
          source="client"
          title={t`Add rate`}
          clientId={store.client.id}
          onSubmit={() => store.refetch?.()}
        />
      ),
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" trapFocus={false}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <span className="mr-3">
                <Trans>System currency</Trans>:
              </span>{" "}
              <CurrencyFlagIcon className="mr-2" code={code} />
              {code}
            </div>
            <Button leftIcon={<Icon name="plus" />} onClick={onAddNewRate}>
              <Trans>Add new rate</Trans>
            </Button>
          </div>

          <ExchangeRatesTable
            source="client"
            ratesGroupedByCurrency={store.ratesGroupedByCurrency}
            onEdit={() => store.refetch?.()}
          />
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="grey" onClick={onClose} variant="outline">
            <Trans>Close details</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
